import { render, staticRenderFns } from "./FinishServicesReservation.vue?vue&type=template&id=c068dff0&scoped=true&"
import script from "./FinishServicesReservation.vue?vue&type=script&lang=js&"
export * from "./FinishServicesReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c068dff0",
  null
  
)

export default component.exports